import instance from './instance';
import { ENV } from '@/constants/env';

const PREFIX_PATH = `${ENV.PRE_FIX}/${ENV.ADMIN_PATH}`;

/**
 * 보스베이비 채팅 세션 DTO
 */
export interface BossBabyChatSessionDto {
  sessionId: number;
  sessionUuid: string;
  comId: number;
  companyName?: string | null;
  userId: string;
  userName?: string | null;
  status: string;
  messageCount: number;
  lastActivity: string;
  regDttm: string;
  messages?: BossBabyChatMessageDto[];
}

/**
 * 보스베이비 채팅 메시지 DTO
 */
export interface BossBabyChatMessageDto {
  messageId: number;
  sessionId: number;
  sender: 'user' | 'ai';
  content: string;
  messageType: string;
  result?: string | null;
  regDttm: string;
}

/**
 * 보스베이비 채팅 로그 API 클라이언트
 *
 * @description 보스베이비 채팅 로그 관련 모든 API 호출을 담당합니다.
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-29
 */
export const bossBabyChatLogApi = {
  /**
   * 보스베이비 채팅 세션 목록 조회
   */
  async getSessions(params?: {
    page?: number;
    limit?: number;
    comId?: number;
    status?: string;
    search?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<{
    list: BossBabyChatSessionDto[];
    count: number;
    page: number;
    limit: number;
  }> {
    const apiUrl = `${PREFIX_PATH}/boss-baby-chat-log/sessions`;
    console.log('[API_CALL]', { url: apiUrl, method: 'GET', params });

    const response = await instance.get(apiUrl, { params });

    console.log('[API_RESPONSE]', {
      url: apiUrl,
      success: response.success,
      dataCount: response.data?.list?.length,
    });

    if (!response.success) {
      throw new Error(response.message || 'API request failed');
    }

    return response.data;
  },

  /**
   * 보스베이비 채팅 세션 상세 조회
   */
  async getSessionDetail(
    sessionUuid: string,
  ): Promise<BossBabyChatSessionDto> {
    const apiUrl = `${PREFIX_PATH}/boss-baby-chat-log/sessions/${sessionUuid}`;
    console.log('[API_CALL]', { url: apiUrl, method: 'GET' });

    const response = await instance.get(apiUrl);

    if (!response.success) {
      throw new Error(response.message || 'Session not found');
    }

    return response.data;
  },
};









